import { Button } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import type { AddUserForm } from "../types";
import AddUserModal from "./AddUserModal";

type Props = {
  onAdd: (values: AddUserForm) => Promise<unknown>;
  isAddUserInProgress: boolean;
};

const AddUserButton = ({ onAdd, isAddUserInProgress }: Props) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();

  return (
    <>
      <Button onClick={() => setModalOpen(true)} icon={<i className="fas fa-plus" style={{ marginRight: "5px" }} />} type="primary">
        {formatMessage({ id: "permissions.user.actions.add" })}
      </Button>
      <AddUserModal onAdd={onAdd} onClose={() => setModalOpen(false)} isAddUserInProgress={isAddUserInProgress} isOpen={isModalOpen} />
    </>
  );
};

export default AddUserButton;
